import React from 'react';
import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CardSkeleton = ({
  className,
  bodyClass,
  footerClass,
  height = '100%',
  minHeight = '400px',
  padding = true,
  footer = true
}) => {
  return (
    <Card className={classNames('h-100 overflow-hidden', className)}>
      <FalconCardHeader title={<Skeleton />} titleTag="h5" light={true} />
      <Card.Body
        className={classNames(
          bodyClass,
          padding ? '' : 'p-0',
          footer ? 'pb-0' : ''
        )}
      >
        <Skeleton height={height} style={{ minHeight: minHeight }} />
      </Card.Body>
      {footer && (
        <Card.Footer className={classNames(footerClass, 'py-4')}>
          <h5 className="mb-0">
            <Skeleton />
          </h5>
        </Card.Footer>
      )}
    </Card>
  );
};
CardSkeleton.propTypes = {
  className: PropTypes.string,
  bodyClass: PropTypes.string,
  footerClass: PropTypes.string,
  height: PropTypes.string,
  minHeight: PropTypes.string,
  padding: PropTypes.bool,
  footer: PropTypes.bool
};
export default CardSkeleton;
